(function () {
    'use strict';

    angular
        .module('salesflare.components.findLeadsDialog', [])
        .factory('sfFindLeadsDialog', sfFindLeadsDialog);

    function sfFindLeadsDialog($mdDialog, $mdMedia) {

        return {
            show
        };

        function show(accountId) {

            return $mdDialog.show({
                clickOutsideToClose: false,
                escapeToClose: true,
                multiple: true,
                hasBackdrop: true,
                controller: 'FindLeadsDialogController',
                controllerAs: 'vm',
                templateUrl: 'app-ajs/components/findleadsdialog/findleadsdialog.html',
                locals: {
                    accountId
                },
                bindToController: true,
                fullscreen: !$mdMedia('gt-sm')
            });
        }

    }
})();
